export default __webpack_public_path__ + "static/media/12-thumbnail.f10e24ec.png";